import * as ics from "ics";

export function createCalendarEvent(
  {
    hour = 0,
    minute = 0,
    diffMinutes = 120,
    day,
    month,
    year,
    title = "",
    location = "",
    url = "",
  },
  type = "digital"
) {
  const digital_event = {
    start: [year, month, day, 19, 0],
    duration: { hours: 29, minutes: 0 },
    title,
    location,
    url,
    status: "CONFIRMED",
    busyStatus: "BUSY",
  };
  const regular_event = {
    start: [year, month, day, hour, minute],
    duration: { minutes: diffMinutes },
    title,
    location,
    url,
    status: "CONFIRMED",
    busyStatus: "BUSY",
  };

  ics.createEvent(
    { digital: digital_event, onSite: regular_event }[type],
    (error, value) => {
      if (error) {
        console.warn(error);
        return;
      }
      downloadFile({
        mimeType: "text/calendar",
        fileContents: value,
        fileName: title.replaceAll(" ", "-") + ".ics",
      });
    }
  );
}

function downloadFile(config) {
  const { mimeType, fileContents, fileName } = config;
  const blob = new Blob([fileContents], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
